import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import extractText from '../../common/utils/extractText';
import Stream from '../../common/utils/Stream';
import ItemList from '../../common/utils/ItemList';
import Form from '../../common/components/Form';
/**
 * The `ForgotPasswordModal` component displays a modal which allows the user to
 * enter their email address and request a link to reset their password.
 */
export default class ForgotPasswordModal extends FormModal {
  constructor() {
    super(...arguments);
    /**
     * The value of the email input.
     */
    _defineProperty(this, "email", void 0);
    _defineProperty(this, "success", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.email = Stream(this.attrs.email || '');
  }
  className() {
    return 'ForgotPasswordModal Modal--small';
  }
  title() {
    return app.translator.trans('core.forum.forgot_password.title');
  }
  content() {
    if (this.success) {
      return m("div", {
        className: "Modal-body"
      }, m(Form, {
        className: "Form--centered"
      }, m("p", {
        className: "helpText"
      }, app.translator.trans('core.forum.forgot_password.email_sent_message')), m("div", {
        className: "Form-group Form-controls"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        onclick: this.hide.bind(this)
      }, app.translator.trans('core.forum.forgot_password.dismiss_button')))));
    }
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered",
      description: app.translator.trans('core.forum.forgot_password.text')
    }, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    const emailLabel = extractText(app.translator.trans('core.forum.forgot_password.email_placeholder'));
    items.add('email', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "email",
      type: "email",
      placeholder: emailLabel,
      "aria-label": emailLabel,
      bidi: this.email,
      disabled: this.loading
    })), 50);
    items.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.forum.forgot_password.submit_button'))), -10);
    return items;
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/forgot',
      body: this.requestParams(),
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      this.success = true;
      this.alertAttrs = null;
    }).catch(() => {}).then(this.loaded.bind(this));
  }
  requestParams() {
    const data = {
      email: this.email()
    };
    return data;
  }
  onerror(error) {
    if (error.status === 404 && error.alert) {
      error.alert.content = app.translator.trans('core.forum.forgot_password.not_found_message');
    }
    super.onerror(error);
  }
}
flarum.reg.add('core', 'forum/components/ForgotPasswordModal', ForgotPasswordModal);